module.exports = __webpack_public_path__ + "static/media/bs.44a5b1bb.svg";